import { useMemo } from 'react';
import { AnyType } from '@src/models/common';

export const useMergedValue = <T extends AnyType>({
  value,
  propsValue,
  fallbackValue,
}: {
  value: T;
  propsValue?: T;
  fallbackValue?: T;
}) => {
  const mergedValue = useMemo(() => {
    if (propsValue !== undefined) return propsValue;
    return fallbackValue ? value || fallbackValue : value;
  }, [value, propsValue, fallbackValue]);

  return { mergedValue };
};
